<div class="flights-container">
    <div class="top-content">
        <app-tab-menu></app-tab-menu>
        <div class="containerTotals" *ngIf="flightTotalsData$ | async as flightTotals">
            <div *ngIf="flightTotals.length > 0; else emptyTotals">
                <app-data-box headerTitle="Flight Totals" [dataBoxItems]="flightTotals"
                    [helpComponent]="flightTotalsInfoDialog" [footer]="dialogFooterFlightTotals">
                </app-data-box>
            </div>
        </div>
        <ng-template #emptyTotals>
            <p-fieldset>
                <ng-template pTemplate="header">
                    <div class="header-title">
                        {{headerTitle}}
                        <i class="pi pi-question-circle help-icon"></i>
                    </div>
                </ng-template>
                <div class="content" *ngIf="skeletonData">
                    <div class="data-item" *ngFor="let item of skeletonData; let i = index;"
                        [class.left-divider-1]="i > 0">
                        <p-skeleton width="50px" height="21px" />
                        <div class="item-label">{{item.label}}</div>
                    </div>
                </div>
            </p-fieldset>
        </ng-template>
    </div>
    <router-outlet></router-outlet>
</div>